<h2><b>Select Question(s):</b></h2>

<p [ngClass]="{green: activeQuestionCount < 3, red: activeQuestionCount === 3}">
  {{activeQuestionCount === null ? '0' : activeQuestionCount}}/3 Questions Selected
</p>

<form [formGroup]="formGroup" class="split-columns">
  <div class="left-column" formGroupName="staticQuestions">
    <section class="question-category" id="{{header}}-section" *ngFor="let header of headerList">

      <h5 class="question-category-heading">{{ header | translate | uppercase }}</h5>

      <div *ngFor="let question of filterQuestionsByHeader(header); let questionIndex = index">
        <div class="question-container" *ngIf="question.headerKey === header">
          <input type="checkbox"
                 [checked]="question.selected"
                 #questionComponentCheckbox
                 [id]="'staticQuestion' + question.questionId"
                 [formControlName]="'staticQuestion' + question.questionId"
                 (click)="handleCheckboxClickedEvent(question, questionIndex, $event)"
                 [attr.disabled]="!question.selected && activeQuestionCount >= 3 ? true : null">
          <app-question id="static-question-{{question.questionId}}"
                        [question]="question"
                        [ngClass]="{disabled: !question.selected}">
          </app-question>
        </div>
      </div>
    </section>
  </div>

  <div class="right-column">
    <section class="question-category" formGroupName="customQuestions">
      <h5 class="question-category-heading">CUSTOM (SELECT TO CUSTOMIZE)</h5>

      <div *ngFor="let question of customQuestionsList; let questionIndex = index">
        <div class="question-container">
          <input type="checkbox"
                 [checked]="question.selected"
                 #questionComponentCheckbox
                 [id]="'customQuestion' + (questionIndex + 1)"
                 [formControlName]="'customQuestion' + (questionIndex + 1)"
                 (click)="handleCheckboxClickedEvent(question, questionIndex, $event)"
                 [attr.disabled]="!question.selected && activeQuestionCount >= 3 ? true : null">
          <app-question id="custom-question-{{question.customQuestionId}}"
                        [question]="question"
                        [formControlName]="'customQuestionText' + (questionIndex + 1)"
                        [pageState]="pageState"
                        [ngClass]="{disabled: !question.selected}">
          </app-question>
        </div>
      </div>
    </section>
    <section *ngIf="aiGeneratedFeature" class="question-category" formGroupName="aiQuestions">
      <h5 class="question-category-heading">AI SUGGESTED</h5>

      <div *ngFor="let question of aiQuestionsList; let questionIndex = index">
        <div class="question-container">
          <input type="checkbox"
                 #questionComponentCheckbox
                 [class]="hiddenAiQuestionsMap[questionIndex] ? 'edit-checkbox' : ''"
                 [checked]="question.selected"
                 [id]="'aiQuestion' + (questionIndex + 1)"
                 [formControlName]="'aiQuestion' + (questionIndex + 1)"
                 (click)="handleCheckboxClickedEvent(question, questionIndex, $event)"
                 [attr.disabled]="!question.selected && activeQuestionCount >= 3 ? true : null">
          <app-question *ngIf="!hiddenAiQuestionsMap[questionIndex]"
                        id="ai-question-{{question.customQuestionId}}"
                        [question]="question"
                        [pageState]="pageState"
                        [formControlName]="'aiQuestionText' + (questionIndex + 1)"
                        [ngClass]="{disabled: !question.selected}">
          </app-question>
          <app-question-edit-box *ngIf="question.selected && hiddenAiQuestionsMap[questionIndex]"
                                 class="edit-box"
                                 [text]="question.description"
                                 (textChangeEmitter)="updateCustomQuestionText(questionIndex, $event)">
          </app-question-edit-box>
          <button *ngIf="question.selected && !hiddenAiQuestionsMap[questionIndex]" [id]="'edit-button-' + question.questionId" (click)="showEditBox(questionIndex)">Edit</button>
        </div>
      </div>
    </section>
  </div>
</form>
